import { TIME } from "../time/time";

/**
 * Idle time before the platform reports the user as away.
 *
 * Screen lock is reported by IdleDetector regardless of this threshold, so it
 * only governs the "no input for a while" axis. 15 minutes matches the intent
 * of the desktop wrapper.
 */
const AFK_THRESHOLD = TIME.MINUTE * 15;

export class BrowserPlatform implements IPlatform {
    private _afkCbs: ((afkState: boolean) => void)[];
    state: PlatformState;
    private _ac: AbortController;

    constructor() {
        this._afkCbs = [];
        this.state = {
            isAfk: false,
        };
        this._ac = new AbortController();
        this.setup();
    }

    on = {
        afk: (cb: AFKCb) => {
            this._afkCbs.push(cb);
        },
    };
    off = {
        afk: (cb: AFKCb) => {
            this._afkCbs = this._afkCbs.filter((t) => t !== cb);
        },
    };

    get name(): string {
        return "browser";
    }

    async setup() {
        const ac = new AbortController();
        document.addEventListener(
            "click",
            async () => {
                ac.abort();

                try {
                    const permission = await IdleDetector.requestPermission();
                    if (permission !== "granted") {
                        return;
                    }

                    const detector = new IdleDetector();
                    detector.addEventListener(
                        "change",
                        (d) => {
                            const isAfk =
                                d.userState === "idle" ||
                                d.screenState === "locked";

                            if (this.state.isAfk === isAfk) {
                                return;
                            }

                            this.state.isAfk = isAfk;
                            for (const cb of this._afkCbs) {
                                cb(isAfk);
                            }
                        },
                        this._ac,
                    );

                    await detector.start({ threshold: AFK_THRESHOLD });
                } catch (e) {
                    console.log("error while setting up idle detector", e);
                }
            },
            ac,
        );
    }

    dispose() {
        this._ac.abort();
    }
}
